// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-footer {
    background: #0f172a;
    color: white;
    padding: 4rem 1rem;
  }
  
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-content {
    text-align: center;
  }
  
  .footer-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  
  .footer-title-accent {
    color: #fbbf24;
  }
  
  .footer-description {
    max-width: 500px;
    margin: 0 auto 2rem;
    color: #94a3b8;
    font-size: 1.1rem;
  }
  
  .footer-links {
    display: flex;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 2rem;
  }
  
  .footer-link {
    color: #cbd5e1;
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .footer-link:hover {
    color: white;
  }
  
  .footer-copyright {
    color: #64748b;
    font-size: 0.9rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB","sourcesContent":[".app-footer {\n    background: #0f172a;\n    color: white;\n    padding: 4rem 1rem;\n  }\n  \n  .footer-container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .footer-content {\n    text-align: center;\n  }\n  \n  .footer-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n  }\n  \n  .footer-title-accent {\n    color: #fbbf24;\n  }\n  \n  .footer-description {\n    max-width: 500px;\n    margin: 0 auto 2rem;\n    color: #94a3b8;\n    font-size: 1.1rem;\n  }\n  \n  .footer-links {\n    display: flex;\n    justify-content: center;\n    gap: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  .footer-link {\n    color: #cbd5e1;\n    text-decoration: none;\n    transition: color 0.3s ease;\n  }\n  \n  .footer-link:hover {\n    color: white;\n  }\n  \n  .footer-copyright {\n    color: #64748b;\n    font-size: 0.9rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
